import { getDataMapper, mapField } from "@/shared";

export const mapCampaignFiltersToServer = getDataMapper(
    {
        status: mapField("status"),
    },
    {
        shouldAvoidUndefined: true,
    },
);
